import * as React from "react";
import classnames from "classnames";
import { motion } from "motion/react";
import { Icon } from "@grandvisionhq/icons";
import { useDropdownContext } from "../../../../../context/ButtonDropdown/context/ButtonDropdownContext.js";
const posedIcon = {
  "button-dropdown--is-closed": {
    rotate: 0
  },
  "button-dropdown--is-open": {
    rotate: 180
  }
};
const ButtonDropdownIcon = () => {
  const { isDisabled } = useDropdownContext();
  return /* @__PURE__ */ React.createElement(
    motion.span,
    {
      className: classnames("button-dropdown__icon", {
        "button-dropdown__icon--disabled": isDisabled
      }),
      variants: posedIcon,
      "data-t": "button-dropdown__icon"
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "chevron-down" })
  );
};
export {
  ButtonDropdownIcon
};
//# sourceMappingURL=ButtonDropdownIcon.js.map
